import React, { useState, useEffect } from 'react';
import CommonModal from './CommonModal';
import { toast } from 'react-toastify';

const MAX_QTY_DIGITS = 3;

/**
 * Tapping the quantity number on a cart item (instead of the +/- steppers) opens this to type an
 * exact quantity directly - faster than tapping +1 repeatedly to go from 1 to, say, 12. Reuses
 * PeopleCountModal's touch keypad styling (.numberKeypad*, CommonModal.css) since it's the same
 * "type a small number on a touch POS terminal" shape.
 */
const QuantityKeypadModal = ({ isOpen, item, onClose, onConfirm }) => {
  const [qty, setQty] = useState('');

  useEffect(() => {
    if (!isOpen || !item) return;
    setQty(String(item.item_quantity ?? ''));
  }, [isOpen, item]);

  const handleDigit = (digit) => {
    setQty((prev) => {
      if (prev.length >= MAX_QTY_DIGITS) return prev;
      if (prev === '0') return digit === '0' ? prev : digit;
      if (prev === '' && digit === '0') return prev; // no leading zero
      return prev + digit;
    });
  };

  const handleBackspace = () => setQty((prev) => prev.slice(0, -1));
  const handleClear = () => setQty('');

  const handleConfirm = () => {
    const value = Number(qty);
    if (!qty || isNaN(value) || value <= 0) {
      toast.error('Enter a valid quantity');
      return;
    }
    onConfirm(item.cart_id, value);
    onClose();
  };

  if (!item) return null;

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="quantityKeypadModal">
      <div className="checkinFormCard">
        <h4 className="lgTitle pb-1 text-center">Set Quantity</h4>
        <p className="text-center mb-3" style={{ opacity: 0.7 }}>{item.item_name}</p>

        <div className="formStyle">
          <div className="numberKeypad">
            <div className="numberKeypadDisplay">
              {qty || <span className="numberKeypadPlaceholder">Enter quantity</span>}
            </div>
            <div className="numberKeypadGrid">
              {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
                <button
                  type="button"
                  key={digit}
                  className="numberKeypadBtn"
                  onClick={() => handleDigit(digit)}
                >
                  {digit}
                </button>
              ))}
              <button type="button" className="numberKeypadBtn numberKeypadBtn--clear" onClick={handleClear}>
                Clear
              </button>
              <button type="button" className="numberKeypadBtn" onClick={() => handleDigit('0')}>
                0
              </button>
              <button
                type="button"
                className="numberKeypadBtn numberKeypadBtn--backspace"
                onClick={handleBackspace}
                aria-label="Backspace"
              >
                ⌫
              </button>
            </div>
          </div>

          <div className="col-12 text-center pt-3">
            <button className="btn btn-secondary me-2" onClick={onClose}>
              Cancel
            </button>
            <button className="btn iconBtn btnPrimary" onClick={handleConfirm}>
              <span>Confirm</span>
            </button>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default QuantityKeypadModal;
